<ng-template #itemTemplate let-item>
	{{ item.firstName }} {{ item.lastName }}
</ng-template>

<app-dropdown
	(onSelect)="onSelect($event)"
	[placeholder]="placeholder"
	[label]="label"
	[itemGroups]="[{ items: (all$ | async), template: itemTemplate }]"
	[ngModel]="selectedDropDownValue"
>
</app-dropdown>
